import { useMaintenanceWorkflowForwardings } from "@/features/privateCompanies/hooks/maintenance/workflows/useMaintenanceWorkflowForwardings";
import { MaintenaceWorkflowData } from "@/features/privateCompanies/types/maintenance/workflows/maintenanceWorkflows.type";
import { MaintenanceForwardingsDirectiveEntryKlass } from "../../../features/forwardings/types/maintenanceForwardingsDirectiveEntryKlasses.type";
import { MaintenanceWorkflowForwardingsData } from "../../../types/maintenanceWorkflowForwardings.type";
import MaintenanceWorkflowForwardingShow from "./MaintenanceWorkflowForwardingShow";
import MaintenanceWorkflowForwardingShowLoading from "./MaintenanceWorkflowForwardingShowLoading";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";

interface MaintenanceWorkflowDiagnosticEntryProps {
  workflow?: MaintenaceWorkflowData;
}

const MaintenanceWorkflowForwardingsTab = ({ workflow }: MaintenanceWorkflowDiagnosticEntryProps) => {
  const {
    data: forwardings,
    isPending: forwardingsIsPending,
    error: forwardingsError = {} as any,
    refetch: refetchForwardings,
  } = useMaintenanceWorkflowForwardings<MaintenanceWorkflowForwardingsData[]>({
    workflowId: workflow?.id,
    filters: {
      directiveEntryType: MaintenanceForwardingsDirectiveEntryKlass.DiagnosticEntry
    },
  });

  if (forwardingsIsPending) {
    return <MaintenanceWorkflowForwardingShowLoading />
  }

  return (
    <ErrorMessageWrapper
      className="flex-1"
      statusCode={forwardingsError?.status}
      refetchFunction={refetchForwardings}
    >
      <div className="flex-1 overflow-auto flex flex-col">
        {forwardings.map((forwarding) => (
          <MaintenanceWorkflowForwardingShow
            key={forwarding.id}
            forwardingId={forwarding.id}
          />
        ))}
      </div>
    </ErrorMessageWrapper>
  );
}

export default MaintenanceWorkflowForwardingsTab;
